<template>
  <div class="Login">
    <div class="f-1">
      <div class="content-sm">
        <div class="LoginButtons">
            <span id="LinkGoToLogin" class="RouteLink-Active">Giriş Yap</span>
            <span id="LinkGoToRegister" v-if="!tcknoConsumerLoginFlow" @click="routeToRegister" class="RouteLink-Passive">Üye Ol</span>
        </div>
        <ValidationObserver v-slot="{ invalid }">
          <form @submit.prevent="onSubmit">
            <ValidationProvider name="E-Posta veya TCKN" rules="required|isTcknOrEmail" v-slot="{ errors }">
              <div class="mb-60" :class="{'with-error': errors[0]}">
                <Input
                  id="InputEmailTC"
                  placeholder="E-Posta veya T.C. Kimlik Numaranız"
                  :readOnly="tcknoConsumerLoginFlow"
                  v-model="email"
                />
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider name="Şifre" rules="required|noStartWithX:0|noWhiteSpaces|min:6|max:20|noRepeatedChars" v-slot="{ errors }">
              <div class="mb-40" :class="{'with-error': errors[0]}">
                <PasswordInput id="InputPassword" placeholder="Şifreniz" v-model="password" />
                <span>{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <div class="d-flex a-center mb-20">
              <Switcher id="SwitchRemember" v-model="remember">Beni Hatırla</Switcher>
              <router-link
                id="LinkGoToForgotPassword"
                to="/forgot-password"
                class="ml-auto"
              >Şifremi Unuttum</router-link>
            </div>
              <Recaptcha v-if="reCaptchaLimitExceeded" ref="recaptcha" @loaded="loadedRecaptcha" @verify="submit"></Recaptcha>
            <button
              id="BtnContinue"
              type="submit"
              @click.prevent="onSubmit"
              :disabled="disabled||invalid"
            >Giriş Yap</button>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions,mapGetters} from "vuex";
import GeneralUtil from "../lib/util/generalUtil"
import router from "../lib/router"

export default {
  name: "QuickPayLogin",
  components: {
    Switcher: () => import("../lib/components/Switcher"),
    QRCode: () => import("../lib/components/QRCode"),
    Input: () => import("../lib/components/Input"),
    PasswordInput: () => import("../lib/components/PasswordInput"),
    Recaptcha: () => import("../lib/components/Recaptcha")
  },
  data: function () {
    let rememberCookie = this.$cookie.get('remember');
    let nameCookie = this.$cookie.get('username');
    return{
      remember: false,
      email: rememberCookie ? this.checkTCKNMask(nameCookie) : "",
      password: "",
      token:"",
      //Temp
      showTokenInput:false,
      grecaptcha: "",
      tcknoConsumerLoginFlow: false
    }
  },
  created(){
    //console.log("Quickpay created-cToken:"+this.$route.query.cToken);
    this.token=this.$route.query.cToken;
    this.setQuickpayFlow(true);
    this.setPayByLinkFlow(false);
    this.setNewPurchaseInfo({token:this.token});
    //console.log("initInfo:",this.initInfo)
    if(this.initInfo.token===null||this.initInfo.token===""){
      this.getQuickPayInfo({token: this.token});
    }else{
      this.token = this.initInfo.token;
      this.checkMerchantUserConsumerInfo();
    }
  },
    mounted(){
      //console.log("Quickpay Mounted-cToken:"+this.$route.query.cToken);
      //this.getTransactionInfo(this.purchaseInfo);
      this.setQuickpayFlow(true);
      this.setLoading(false);
    },
    computed: {
        ...mapGetters({
            qrtext:'getEmvQrText',
            initInfo:'getInitInfo',
            purchaseInfo:'getPurchaseInfo',
            capchaEnable:'getCapchaEnable',
            reCaptchaLimitExceeded: 'reCaptchaLimitExceeded',
            merchantUserInfo: 'getMerchantUserInfo'
    }),
    disabled() {
      return !this.email || !this.password;
    }
  },
  watch: {
      "merchantUserInfo.validMerchantType": function (val) {
          if (val === true) {
              this.checkMerchantUserConsumerInfo();
          }
      }
  },
  methods: {
    ...mapActions({
        login: 'login',
        getTransactionInfo:'getTransactionInfo',
        verifyCaptchaOnSubmit: 'verifyCaptchaOnSubmit',
        setQuickpayFlow: 'setQuickpayFlow',
        loginForCardMatch:'loginForCardMatch',
        getQuickPayInfo:'getQuickPayInfo',
        setNewPurchaseInfo:'setNewPurchaseInfo',
        setPayByLinkFlow:'setPayByLinkFlow',
        setLoading:'setLoading'

    }),
    routeToRegister(){
      router.push('/register');
    },
    onSubmit() {
      this.loginForCardMatch({name:this.email,password:this.password,token:this.token,remember:this.remember, clearCaptcha:this.reCaptchaLimitExceeded});
    },
    checkTCKNMask: function (name) {
      let newName = name;
      if (GeneralUtil.isTcknValid(name)) {
        newName = name.substring(0, 3) + "******" + name.substring(9, 11);
      }
      return newName;
    },
    loadedRecaptcha: function (grecaptcha) {
      this.grecaptcha = grecaptcha;
    },
    submit: function (response) {
      this.verifyCaptchaOnSubmit({response:response,username:this.email});
    },
    checkMerchantUserConsumerInfo() {
        if (this.merchantUserInfo.validMerchantType === true && this.merchantUserInfo.identity != undefined && this.merchantUserInfo.identity != null && this.merchantUserInfo.identity !== '') {
            if (this.merchantUserInfo.exist === true) {
                this.email = this.merchantUserInfo.identity;
                this.tcknoConsumerLoginFlow = true;
            } else {
                this.tcknoConsumerLoginFlow = false;
                this.routeToRegister();
            }
        } else {
            this.tcknoConsumerLoginFlow = false;
        }
    }
  },

};
</script>